'use strict';
module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


/*****************
 ** WEBPACK FOOTER
 ** ./~/dom-helpers/util/inDOM.js
 ** module id = 608
 ** module chunks = 0
 **/